// details.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-details',
  template: `
    <ng-container *ngIf="!vueDetailsAgent">
        <div class="card">
          <div class="card-body">
            <h2>
              <b>{{ typeAction }} salaire :
                <span style="color: #198754">{{ salaire.qualite }} {{ salaire.nom }} {{ salaire.prenoms }}</span>
                | {{ salaire.matricule }}
              </b>
            </h2>
            <div style="display: flex; justify-content: flex-end; position: absolute; top: 4%; right: 1%;">
              <button class="btn btn-dark" style="margin-left: 8px;" (click)="closeDetailsAgent.emit()">
                <i class="ti-close"></i>
              </button>
            </div>
            <app-form [form]="form" [lists]="salaire" [vueListAgent]="vueListAgent"></app-form>
        </div>
      </div>
    </ng-container>
  `
})
export class DetailsComponent {
  @Input() salaire: any;
  @Input() form: any;
  @Input() typeAction: string;
  public vueDetailsAgent: boolean;
  @Output() closeDetailsAgent = new EventEmitter<void>();
}
